import AnalyticsStatus from '@app/components/ui/analytics-status/analytics-status';
import useTranslation from '@app/hooks/use-translation';
import {
  MonitoringFormTaskObjectType,
  MonitoringFormTasksStatusesType,
} from '@app/interfaces/qm-module/qm-manage/qm-monioring-tasks.type';
import { useGetUserInfoQuery } from '@app/store/api/get-user-info.api';
import { useChangeStatusMFTaskMutation } from '@app/store/api/qm-module/qm-manage/qm-manage-monitoring-tasks.api';
import { Button, PageHeader } from '@ui';
import React, { FC } from 'react';
type MonitoringTaskSettingsHeadPropsType = {
  mFTaskObject: MonitoringFormTaskObjectType | undefined;
  isNew?: boolean;
};
const toggleStatusChangeMap: Partial<
  Record<MonitoringFormTasksStatusesType, MonitoringFormTasksStatusesType>
> = {
  NEW: 'STARTING',
  ACTIVE: 'PAUSE',
  PAUSE: 'ACTIVE',
  STARTING: 'NEW',
};

const MonitoringTaskSettingsHead: FC<MonitoringTaskSettingsHeadPropsType> = ({
  mFTaskObject,
  isNew,
}) => {
  const { t } = useTranslation('pages.qmManage.monitoring_tasks');

  // const { t: tStatuses } = useTranslation('components.reportsStatusLabel');
  const { data: userInfo } = useGetUserInfoQuery();
  const [changeMFTaskStatus] = useChangeStatusMFTaskMutation();

  function handleChangeStatus(status: MonitoringFormTasksStatusesType, id: string) {
    changeMFTaskStatus({ status, id }).unwrap();
  }
  function handleToggleStatus(status: MonitoringFormTasksStatusesType, id: string) {
    const statusToChange = toggleStatusChangeMap?.[status];
    if (!statusToChange) return;
    handleChangeStatus(statusToChange, id);
  }

  const buttonLabels = {
    new: t('form.start_project'),
    active: t('form.pause_project'),
    pause: t('form.start_project'),
  };

  return (
    <PageHeader
      popLink={`./..`}
      label={
        <div className="flex items-center gap-[10px]">
          <div className="mt-[-2px] font-[600]">
            {isNew ? t('form.new_task_title') : mFTaskObject?.name}
          </div>
          {!isNew && (
            <AnalyticsStatus
              qmMode
              additionalStatusList={{ NEW: { title: t('new_status') } }}
              status={mFTaskObject?.status || 'NEW'}
            />
          )}
        </div>
      }
    >
      {userInfo?.qm_role !== 'controller' &&
        ['new', 'active', 'pause'].includes(mFTaskObject?.status?.toLowerCase() || '') && (
          <Button
            icon={mFTaskObject?.status === 'ACTIVE' ? 'PauseIcon' : 'TriangleRightIcon'}
            sizeIcon={15}
            fill="outlined"
            onClick={() =>
              handleToggleStatus(mFTaskObject?.status || 'NEW', mFTaskObject?.id || '')
            }
            label={buttonLabels[mFTaskObject?.status?.toLowerCase() || 'new']}
          />
        )}
    </PageHeader>
  );
};

export default MonitoringTaskSettingsHead;
